import { Stack, Switch } from '@eleveo/components-react';
import React, { useMemo } from 'react';
import { useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { useIntegrations } from '../../../../app/IntegrationsProvider';
import { TEST_IDS } from '../../../../constants/dataTestIds';
import { getSupportedStreams } from '../../../../scene/integrations/config';
import { REAL_TIME_DATA_FIELDS, STREAM_NAMES } from '../../../../scene/integrations/types';
import { getStreamFormOrder } from '../../../../utils/formUtils';

export const RealTimeData: React.FC = () => {
  const { isInReadOnlyMode, integrationType } = useIntegrations();
  const { t } = useTranslation();

  const availableStreams = useMemo(() => getSupportedStreams(integrationType), [integrationType]);
  const realTimeDataOrder = getStreamFormOrder(STREAM_NAMES.realTimeData, availableStreams);

  const { input: enabledInput } = useField(REAL_TIME_DATA_FIELDS(realTimeDataOrder).enabled);

  return (
    <Stack direction="vertical" className="p-20 w-full" spacing={20}>
      <Switch
        className="w-full"
        isSelected={enabledInput.value}
        isDisabled={isInReadOnlyMode}
        {...enabledInput}
        testId={TEST_IDS.checkboxRealTimeDataEnabled}
      >
        {t(`myConfigurations.tasks.${enabledInput.value ? 'on' : 'off'}`)}
      </Switch>
    </Stack>
  );
};
